export default __webpack_public_path__ + "static/brand-logo-stonehouse-24a7c8936613c77eb81a37b5ad2e1bbd.png";